import React, { useEffect, useState } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import amusement from '../img/amusement.png';
import micro from '../img/micro.png';
import romanticDinner from '../img/romantic-dinner.png';
import cooking from '../img/cooking.png';
import mackCheez from '../img/mack-cheez.jpg';
import decor from '../img/decor.png';
import spa from '../img/spa.png';
import airplane from '../img/airplane.png';
import camping from '../img/camping.png';
import netflix from '../img/netflix.png';
import board from '../img/board.png';
import sheets from '../img/sheets.png';
import wine from '../img/wine.png';
import plant from '../img/plant.png';
import painting from '../img/painting.png';
import dancing from '../img/dancing.png';
import exprimidor from '../img/exprimidor.png';
import washer from '../img/wahser.png';
import liverpool from '../img/liverpool.png';
import Payment from '../components/Payment';
import StripeBuyButton from '../components/StripeBuyButton';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const giftOptions = [
  {
    name: 'Entradas a parques de diversiones',
    price: 3000,
    description: 'Ayúdanos a disfrutar de un día lleno de diversión.',
    image: amusement,
  },
  {
    name: 'Delicias para nuestros perros',
    price: 500,
    description: 'Nuestros amigos peludos te lo agradecerán.',
    image: mackCheez,
  },
  {
    name: 'Un nuevo microondas',
    price: 2500,
    description: 'Haz que nuestra cocina sea más moderna.',
    image: micro,
  },
  {
    name: 'Cena romántica para dos',
    price: 2000,
    description: 'Regálanos una noche especial juntos.',
    image: romanticDinner,
  },
  {
    name: 'Clase de cocina gourmet',
    price: 1800,
    description: 'Ayúdanos a aprender recetas deliciosas.',
    image: cooking,
  },
  {
    name: 'Decoración para nuestro hogar',
    price: 1200,
    description: 'Contribuye a embellecer nuestro espacio.',
    image: decor,
  },
  {
    name: 'Experiencia de spa para dos',
    price: 2500,
    description: 'Relájate y disfruta de un día de spa con nosotros.',
    image: spa,
  },
  {
    name: 'Boletos de avión a Orlando',
    price: 15000,
    description: 'Contribuye al viaje de nuestros sueños.',
    image: airplane,
  },
  {
    name: 'Equipamiento de camping',
    price: 3000,
    description: 'Facilítanos nuestras futuras aventuras al aire libre.',
    image: camping,
  },
  {
    name: 'Mes de suscripción a Netflix',
    price: 230,
    description: 'Disfrutemos de películas y series juntos.',
    image: netflix,
  },
  {
    name: 'Un juego de mesa divertido',
    price: 600,
    description: 'Regálanos horas de entretenimiento.',
    image: board,
  },
  {
    name: 'Juego de Sábanas Premium',
    price: 2200,
    description:
      'Ayúdanos a disfrutar de noches cómodas con sábanas suaves y elegantes.',
    image: sheets,
  },
  {
    name: 'Cesta de frutas y vinos',
    price: 1500,
    description: 'Un regalo delicioso y sofisticado.',
    image: wine,
  },
  {
    name: 'Una planta de interior',
    price: 400,
    description: 'Llena nuestro hogar de vida y frescura.',
    image: plant,
  },
  {
    name: 'Cuadro decorativo personalizado',
    price: 2000,
    description: 'Añade un toque único a nuestro hogar.',
    image: painting,
  },
  {
    name: 'Clases de baile para dos',
    price: 1800,
    description: '¡Aprendamos unos pasos nuevos juntos!',
    image: dancing,
  },
  {
    name: 'Exprimidor de limones',
    price: 180,
    description:
      'Perfecto para preparar bebidas refrescantes y darle un toque cítrico a nuestras recetas favoritas.',
    image: exprimidor,
  },
  {
    name: 'Lavadora',
    price: 5900,
    description:
      'Un regalo práctico para ayudarnos a mantener nuestra ropa siempre impecable.',
    image: washer,
  },
];
const UnderConstruction: React.FC = () => {
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<'bank' | 'stripe'>('bank');
  const [selectedGift, setSelectedGift] = useState<{
    name: string;
    price: number;
    image: string;
  } | null>(null);

  useEffect(() => {
    fetch(`${baseUrl}/config`).then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);

  const closeModal = () => {
    setSelectedGift(null);
  };

  return (
    <section className="flex flex-col items-center justify-center min-h-screen text-center px-2 bg-[#F7F4EF]">
      <div className="mb-16">
        <h1 className="text-4xl font-serif text-[#B94665] uppercase mb-4 mt-8 md:mt-20">
          Mesa de regalos
        </h1>
        <p className="text-gray-600 text-lg italic mb-8">
          ¡Tu presencia es el mejor regalo! Pero nos puedes ayudar a crear
          recuerdos inolvidables con estas sugerencias.
        </p>

        {/* Gift Options */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1 md:gap-4 lg:gap-12 px-1 md:px-4 lg:px-12">
          {giftOptions.map((gift, index) => (
            <div
              key={index}
              onClick={() =>
                setSelectedGift({
                  name: gift.name,
                  price: gift.price,
                  image: gift.image,
                })
              }
              className="pb-4 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg flex flex-col items-center hover:shadow-xl transition-shadow duration-300 cursor-pointer"
            >
              <img
                src={gift.image}
                alt={gift.name}
                className="w-full h-40 lg:h-60 object-cover rounded-t-lg mb-4"
              />
              <div className="flex flex-col items-center text-center px-2 flex-grow">
                <h2 className="text-lg font-bold text-[#B94665] mb-2">
                  {gift.name}
                </h2>
                <p className="hidden md:block text-gray-500 text-sm italic mb-4">
                  {gift.description}
                </p>
                <p className="text-lg font-semibold text-gray-800">
                  ${gift.price.toLocaleString('es-MX')} MXN
                </p>
              </div>
              <div className="mt-auto">
                <button className="mt-4 px-6 py-2 bg-[#B94665] text-white text-sm font-semibold hover:bg-[#9c3b57] transition-colors duration-300">
                  REGALAR
                </button>
              </div>
            </div>
          ))}
          <StripeBuyButton />
        </div>
        <div className="text-gray-600 text-lg italic mt-10">
          <img 
            src={liverpool} 
            alt="Liverpool" 
            className="mx-auto w-[15em] h-auto" />
          <p className="mt-4">Número de evento: 51597284</p>
          <p>Haz clic en el siguiente enlace para ver nuestra lista de regalos:</p>
          <a href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/51597284" target="_blank" className="underline">
            Ir a la mesa de regalos en Liverpool
          </a>
        </div>

        {/* Payment Modal */}
        {selectedGift && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
            onClick={() => {
              setSelectedGift(null);
              setPaymentMethod('bank'); // Reset payment method when modal is closed
            }}
          >
            <div
              className="relative w-full max-w-lg p-8 bg-white rounded-lg shadow-lg"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="absolute top-2 right-2 w-12 h-12 flex items-center justify-center rounded-full bg-[#F7F4EF] text-[#B94665] text-2xl hover:bg-[#B94665] hover:text-white transition-all duration-300 focus:outline-none focus:ring focus:ring-[#B94665] focus:ring-opacity-50"
                onClick={() => {
                  setSelectedGift(null);
                  setPaymentMethod('bank');
                }}
              >
                &times;
              </button>

              {/* Thank You Title */}
              <h2 className="text-2xl font-bold text-[#B94665] text-center mb-4">
                ¡MUCHAS GRACIAS!
              </h2>
              <p className="text-center text-gray-500 italic mb-6">
                ¡Gracias por ayudarnos a hacer de este día algo inolvidable!
              </p>

              {/* Gift Information */}
              {paymentMethod === null && (
                <>
                  <div className="flex flex-col items-center mb-6">
                    <img
                      src={selectedGift.image}
                      alt={selectedGift.name}
                      className="w-40 h-40 object-cover rounded-lg mb-4"
                    />
                    <h3 className="text-lg font-semibold text-[#B94665]">
                      {selectedGift.name}
                    </h3>
                    <p className="text-gray-600 text-lg">
                      ${selectedGift.price.toLocaleString('es-MX')} MXN
                    </p>
                  </div>
                </>
              )}

              {/* Payment Method */}
              {paymentMethod === 'bank' && (
                <div className="text-center">
                  <div className="mt-6 text-center">
                    <p className="text-xl font-semibold text-[#B94665] mb-4">
                      Información para Depósito
                    </p>
                    <div className="bg-gray-100 p-4 rounded-lg shadow-md">
                      <p className="text-gray-700 mb-2">
                        <strong>Banco:</strong> Inbursa
                      </p>
                      <p className="text-gray-700 mb-2">
                        <strong>Tarjeta:</strong> 4658 2850 1898 5378
                      </p>
                      <p className="text-gray-700 mb-2">
                        <strong>CLABE:</strong> 036680500714542612
                      </p>
                      <p className="text-gray-700">
                        <strong>Titular:</strong> Getsemani Tapia Osornio
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => setPaymentMethod('stripe')}
                    className="mt-6 w-full px-6 py-3 bg-[#B94665] text-white text-sm font-semibold rounded-lg hover:bg-[#9c3b57] transition-colors"
                  >
                    Pagar con Tarjeta
                  </button>
                </div>
              )}

              {paymentMethod === 'stripe' && (
                <div className="mt-6">
                  <Payment
                    stripePromise={stripePromise}
                    price={selectedGift.price}
                  />
                  <button
                    onClick={() => setPaymentMethod('bank')}
                    className="flex items-center justify-center gap-2 py-2 text-sm font-semibold text-gray-800 mt-4 rounded-full hover:bg-gray-200 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                    Pagar con Depósito
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default UnderConstruction;
